module.exports = __webpack_public_path__ + "img/mnemo-tatyana.79c36ceb.jpg";